/**
 * Surfaces IndexedDB leftovers the per-meeting recovery probe cannot see —
 * especially crashed provisional (offline) recordings whose URL is no longer
 * open. Clicking through lands on the meeting page, which already owns the
 * resume / submit / discard banner.
 */
import { msg } from "@lingui/core/macro"
import { useLingui } from "@lingui/react"
import { Trans } from "@lingui/react/macro"
import { Anchor, Text } from "@mantine/core"
import { Link } from "@tanstack/react-router"
import { useEffect, useState } from "react"
import { type ISavedRecordingMeta, listSavedRecordings } from "../../hooks/useIndexedDB"

export function RecoveredRecordingsBanner(): React.JSX.Element | null {
  const { i18n } = useLingui()
  const [items, setItems] = useState<ISavedRecordingMeta[]>([])

  useEffect(() => {
    void listSavedRecordings().then((all) => {
      // One row per meeting (room channel). Remote siblings recover from the
      // same meeting page.
      const room = all.filter((r) => r.channel === "room")
      setItems(room)
    })
  }, [])

  if (items.length === 0) return null

  return (
    <Text size="sm" c="dimmed" mb="md">
      <Trans>Unfinished recordings in this browser:</Trans>{" "}
      {items.map((item, i) => (
        <span key={`${item.meetingId}:${item.channel}`}>
          {i > 0 ? ", " : null}
          <Anchor renderRoot={(props) => <Link to="/meetings/$id" params={{ id: item.meetingId }} {...props} />}>
            {item.subject?.trim() ||
              (item.isProvisional ? i18n._(msg`Unsaved recording`) : i18n._(msg`Unfinished recording`))}
          </Anchor>
        </span>
      ))}
    </Text>
  )
}
